import { render, staticRenderFns } from "./TaskResultsReActivate.vue?vue&type=template&id=4d5a522e&"
import script from "./TaskResultsReActivate.vue?vue&type=script&lang=js&"
export * from "./TaskResultsReActivate.vue?vue&type=script&lang=js&"
import style0 from "./TaskResultsReActivate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports